import { useEffect, useState } from "react"
import { getBloodTrackerByUserId } from "../../../utils/apis/tracker-service"
import { useAuth } from "../../../utils/context/AuthContext"
import { BloodTestTrackingStatus } from "../../../utils/Enums"
import { handleBloodTrackerText, handleDayOfMonth, handleMonth, handleYear } from "../../../utils/Functions"

export const useGetBloodTracker = (patientId: string | null) => {
    const { auth } = useAuth()
    const idToken = auth.idToken

    const [isLoading, setIsLoading] = useState(true);
    const [bloodTracker, setBloodTracker] = useState<{ status: string | null; date: string | null }>({ status: null, date: null });
    const [bloodPickupDate, setBloodPickupDate] = useState<string | undefined>();

    useEffect(() => {
        if (!patientId || !idToken) return;
        getBloodTrackerByUserId(
            patientId,
            idToken,
            (trackers) => {
                const tracker = trackers[0]
                const status = tracker.tracking_status
                const statusText = handleBloodTrackerText(status)
                const date = tracker.updated_at
                const dateText = `${handleDayOfMonth(date)} ${handleMonth(date)} ${handleYear(date)}`
                setBloodTracker({ status: statusText, date: dateText })
                if (
                    status === BloodTestTrackingStatus.PickupRequested ||
                    status === BloodTestTrackingStatus.DeliveredToLab ||
                    status === BloodTestTrackingStatus.ReportGenerated
                ) {
                    const pickupEntry = tracker.tracking_history.find(
                        (entry) => entry.status === BloodTestTrackingStatus.PickupRequested
                    );

                    if (pickupEntry) {
                        const date = pickupEntry.date;
                        setBloodPickupDate(`${handleDayOfMonth(date)} ${handleMonth(date)} ${handleYear(date)}`)
                    }
                }
                setIsLoading(false)
            },
            (error) => {
                console.log(error)
                setIsLoading(false)
            }
        )
    }, [patientId, idToken])

    return { bloodTracker, bloodPickupDate, isLoading}
}